import React from 'react';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import { SecondaryActionIconButton, Stack } from '@facet-wealth/design';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const MessagesPanelSkeleton = () => {
  const {
    selectedThreadResource,
    isMessagesInitializing,
    messagesInitializingError,
    selectThread,
  } = useMessagesContext();
  const loadingError = messagesInitializingError || (!isMessagesInitializing && !selectedThreadResource);
  let message = 'Select a thread to view the messages';

  if (isMessagesInitializing && !!selectedThreadResource) {
    message = 'Loading your message...';
  }

  if (loadingError) {
    message = 'Something went wrong. Please try again.';
  }

  return (
    <Stack justifyContent={'center'} alignItems={'center'}>
      <Typography variant={'h4'} color={'primaryGray4'}>
        {message}
      </Typography>
      {loadingError && (
        <SecondaryActionIconButton
          label={'Reload Messages'}
          icon={'refresh'}
          onClick={() => selectThread(selectedThreadResource)}
          size={'lg'}
        />
      )}
    </Stack>
  );
};

MessagesPanelSkeleton.defaultProps = {};

MessagesPanelSkeleton.propTypes = {};

export { MessagesPanelSkeleton };
